/**
 * Created by rhinov15 on 17/03/2016.
 *
 *  Graphical node representing a picture placed on plan (user picture typically a photo)
 */

import { EntityNode } from "./EntityNode";
import { CocosConstants } from "../../../../constants";
import { RotationNode } from "../Nodes/RotationNode";
import { PlanManager } from "../../../../cocosPlan";
import { Events, eventsManager, UserPicture } from "@rhinov/savane-js";

declare var cc: any;

export class PictureNode extends EntityNode {
    constructor(picture: UserPicture) {
        super(picture);
        // Create a sprite we will attach to this node
        this._sprite = new cc.Sprite();

        // Texture list constants
        this.TEXTURE_DEFAULT = CocosConstants.resourcesBasePath + '/resources/camera.png';
        this.TEXTURE_HOVERED = CocosConstants.resourcesBasePath + '/resources/cameraHovered.png';
        this.TEXTURE_SELECTED = CocosConstants.resourcesBasePath + '/resources/cameraSelected.png';

        // Create image sprite
        this._sprite.setTexture(this.TEXTURE_DEFAULT);
        // Scale down by default
        this._sprite.setScale(0.30);
        // Attach sprite node to this node
        this.addChild(this._sprite, -1);
        // Set current node visibility to the value retrieved from plan manager saying if we need to display user pictures
        this.setVisible(PlanManager.getInstance().showUserPictures);

        // This node can be rotated so attach a rotation node to it
        this.rotateSprite = new RotationNode(this.savaneEntity);
        this.addChild(this.rotateSprite, 8);

        // React to user picture toggle button to display/hide them
        this.toogleCameralistener = eventsManager.instance.addListener(Events.TOGGLE_USER_PICTURES, (event: any) => {
            this.setVisible(event.userData);
        });
    }

    // Width and height getters (we return srpite width and height)
    getWidth (): number  {
        return this._sprite.width;
    }

    getHeight (): number {
        return this._sprite.height;
    }

    // Update is a standard parent update
    update (dt: any) {
        super.update(dt);

        if (this._isSelected) {
            this.rotateSprite.setVisible(true);
            this.rotateSprite.update();
        }
        else {
            // Otherwise hide it
            this.rotateSprite.setVisible(false);
        }
    }

    // Say weither or not the sprite can rotate according to the cursor position
    toRotate (position: any) {
        // Just ask the rotation node if it can with the coordinates passed
        return (this.rotateSprite.toRotate(position));
    }

    // Hover node
    setHovered (val: boolean) {
        super.setHovered(val);

        // Selected has priority over hovering
        if (!this._isSelected) {
            if (val) {
                this._sprite.setTexture(this.TEXTURE_HOVERED);
            }
            else {
                this._sprite.setTexture(this.TEXTURE_DEFAULT);
            }
        }
    }

    // Selected node
    setSelected (value: boolean) {
        super.setSelected(value);

        if (value) {
            //Selected
            this._sprite.setTexture(this.TEXTURE_SELECTED);
        }
        else {
            //Unselected
            this._sprite.setTexture(this.TEXTURE_DEFAULT);
        }

    }

    // Remove listeners
    removeListeners () {
        eventsManager.instance.removeListener(this.toogleCameralistener);
    }

    // Object destruction, remove listeners
    onExit () {
        this.removeListeners();
    }
}

